import styled from '@emotion/styled'
import { FC } from 'react'

const GalleryContainer = styled.div`
    max-width: 1080px;
    margin: 2rem auto;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 1rem;

    @media (max-width: ${(props) => props.theme.breakPoints.largePhone}) {
        grid-template-columns: 1fr;
    }
`

const Block = styled.div`
    display: grid;
    gap: 1rem;
`

const TwoTopOneBottom = styled(Block)`
    grid-template-rows: auto auto;
    grid-template-columns: 1fr 1fr;

    & > div:nth-of-type(1),
    & > div:nth-of-type(2) {
        grid-row: 1;
    }

    & > div:nth-of-type(3) {
        grid-column: 1 / span 2;
        grid-row: 2;
    }
`

const OneTopTwoBottom = styled(Block)`
    grid-template-rows: auto auto;
    grid-template-columns: 1fr 1fr;

    & > div:nth-of-type(1) {
        grid-column: 1 / span 2;
        grid-row: 1;
    }

    & > div:nth-of-type(2),
    & > div:nth-of-type(3) {
        grid-row: 2;
    }
`

const GalleryItem = styled.div`
    position: relative;
    width: 100%;
    height: 15rem;
    cursor: pointer;
    overflow: hidden;
    border-radius: 0px;

    &::after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.3);
        opacity: 0;
        transition: opacity 0.3s ease;
    }

    &:hover::after {
        opacity: 1;
    }
`

const GalleryImage = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
    border-radius: 0px;
`

interface GalleryProps {
    data: {
        src: string
        title: string
        description: string
    }[]
    onClick: (index: number) => void
}

const Gallery: FC<GalleryProps> = ({ data, onClick }) => {
    const blocks = []
    for (let i = 0; i < data.length; i += 6) {
        const left = data.slice(i, i + 3)
        const right = data.slice(i + 3, i + 6)
        if (left.length)
            blocks.push(
                <TwoTopOneBottom key={`left-${i}`}>
                    {left.map((item, idx) => (
                        <GalleryItem key={idx} onClick={() => onClick(i + idx)}>
                            <GalleryImage src={item.src} alt={item.description} />
                        </GalleryItem>
                    ))}
                </TwoTopOneBottom>
            )
        if (right.length)
            blocks.push(
                <OneTopTwoBottom key={`right-${i}`}>
                    {right.map((item, idx) => (
                        <GalleryItem key={idx} onClick={() => onClick(i + 3 + idx)}>
                            <GalleryImage src={item.src} alt={item.description} />
                        </GalleryItem>
                    ))}
                </OneTopTwoBottom>
            )
    }

    return <GalleryContainer>{blocks}</GalleryContainer>
}

export default Gallery
